import {createAction} from '@reduxjs/toolkit'

export const updateFeed = createAction('feed/save', (data) => ({
  payload: data
}))

export const clearFeed = createAction('feed/clear')
